import React from "react";

import { AppHeader } from "components/layout/Header";
import Link from "next/link";
import { styled } from "twin.macro";
import { HeaderProps } from "shared/components/atoms/Header";

export const MediaHeader = (props: Omit<HeaderProps, "children">) => {
  return (
    <AppHeader {...props}>
      <Link href="/" passHref>
        <Banner>会員数60万人超の国内最大級の占いサイト ▶ </Banner>
      </Link>
    </AppHeader>
  );
};

const Banner = styled.a`
  background: linear-gradient(#a84fb2, #e68ab4);
  width: 219px;
  height: 24px;
  border-radius: 4px;
  color: #fff;
  font-weight: 600;
  font-size: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
`;
